// SPDX-License-Identifier: MIT
// Azure SAS input utilities: normalization and safe redaction for logs/debug

/** Keys that should be redacted when echoing a SAS query. */
export const REDACT_KEYS = ['sig', 'sp', 'se', 'sr'] as const;

/**
 * Trim and remove accidental surrounding quotes (common when pasting into terminals).
 */
export function normalizeInput(raw: string): string {
  return raw.trim().replace(/^"|"$/g, '');
}

/**
 * Return a redacted representation of a SAS URL or token for safe logging.
 * Note: This is for diagnostics only; never log full tokens.
 */
export function redactSas(urlOrToken: string): string {
  try {
    const hasProtocol = urlOrToken.startsWith('https://');
    const u = hasProtocol ? new URL(urlOrToken) : null;
    const params = hasProtocol
      ? u!.searchParams
      : new URLSearchParams(urlOrToken.replace(/^\?/, ''));
    (REDACT_KEYS as readonly string[]).forEach(k => {
      if (params.has(k)) params.set(k, '***');
    });
    return hasProtocol ? `${u!.origin}${u!.pathname}?${params.toString()}` : params.toString();
  } catch {
    return '[unparseable]';
  }
}
